const fetchWrapper = (url: string, options: RequestInit = {}): Promise<Response> => {
  const csrfToken = document.querySelector<HTMLMetaElement>("[name='csrf-token']")?.content;

  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      ...(csrfToken && { 'X-CSRF-Token': csrfToken }),
    },
  });
};

export default fetchWrapper;
